webpackJsonp([123583172415245],{

/***/ 413:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Map = __webpack_require__(166);
	
	var _Map2 = _interopRequireDefault(_Map);
	
	var _aos = __webpack_require__(30);
	
	var _aos2 = _interopRequireDefault(_aos);
	
	var _CompanyLogos = __webpack_require__(36);
	
	var _CompanyLogos2 = _interopRequireDefault(_CompanyLogos);
	
	var _ActiveWrapper = __webpack_require__(17);
	
	var _ActiveWrapper2 = _interopRequireDefault(_ActiveWrapper);
	
	var _axios = __webpack_require__(31);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _domain = __webpack_require__(38);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var regix = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
	
	var center = { lat: 12.9289354, lng: 77.6267649 };
	
	var mapProps = {
	    options: {
	        center: center,
	        zoom: 18
	    },
	    onMount: function onMount(map) {
	        new window.google.maps.Marker({
	            position: center,
	            map: map,
	            title: 'Hubbler'
	        });
	    }
	};
	
	var Sales = function (_Component) {
	    _inherits(Sales, _Component);
	
	    function Sales() {
	        var _temp, _this, _ret;
	
	        _classCallCheck(this, Sales);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	            args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.state = {
	            name: '',
	            email: '',
	            mobile: '',
	            description: '',
	            loading: false,
	            sent: false,
	            domain: ''
	        }, _temp), _possibleConstructorReturn(_this, _ret);
	    }
	
	    Sales.prototype.submitValidate = function submitValidate() {
	        var _state = this.state,
	            name = _state.name,
	            email = _state.email,
	            mobile = _state.mobile,
	            description = _state.description;
	
	        var checkFormat = regix.test(this.state.email);
	        return name !== '' && email !== '' && checkFormat;
	    };
	
	    Sales.prototype.onChangeHandler = function onChangeHandler(name, event) {
	        var _setState;
	
	        this.setState((_setState = {}, _setState[name] = event.target.value, _setState));
	    };
	
	    Sales.prototype.componentDidMount = function componentDidMount() {
	        var domain = (0, _domain.getDomain)();
	        this.setState({
	            domain: domain
	        });
	    };
	
	    Sales.prototype.onSubmit = function onSubmit() {
	        var _this2 = this;
	
	        var postData = _extends({}, this.state);
	        delete postData.loading;
	        delete postData.sent;
	        this.setState({
	            loading: true
	        });
	        (0, _domain.postCall)('/hubbler/customer-support/', postData).then(function (response) {
	            if (response.data.success) {
	                _this2.setState({
	                    loading: false,
	                    sent: true
	                });
	            } else {
	                alert(response.data.error);
	            }
	        });
	    };
	
	    Sales.prototype.render = function render() {
	        var checkFormat = regix.test(this.state.email);
	        var _state2 = this.state,
	            name = _state2.name,
	            email = _state2.email,
	            mobile = _state2.mobile,
	            description = _state2.description;
	
	        return _react2.default.createElement(
	            'div',
	            { className: 'sales-form-page form-page-container' },
	            _react2.default.createElement(
	                _ActiveWrapper2.default,
	                { active: !this.state.sent },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'form-inputs-container' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'info-details' },
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'head' },
	                            'Customer Support'
	                        ),
	                        _react2.default.createElement(
	                            'p',
	                            null,
	                            'Get in touch with customer support for assistance with your Hubbler product queries. Also, the top queries are listed in our ',
	                            _react2.default.createElement(
	                                'a',
	                                { href: 'https://help.hubbler.mobi/faq/', target: '_blank' },
	                                'FAQs'
	                            ),
	                            ', do check it out.'
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: this.state.loading ? 'inputs-list loading-disable' : 'inputs-list' },
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'inputs' },
	                            _react2.default.createElement(
	                                'label',
	                                null,
	                                'Name'
	                            ),
	                            _react2.default.createElement('input', { type: 'text', placeholder: 'e.g., John Smith', autoFocus: true, onChange: this.onChangeHandler.bind(this, 'name'), defaultValue: name, disabled: this.state.loading ? true : false })
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'inputs' },
	                            _react2.default.createElement(
	                                'label',
	                                null,
	                                'Company Email'
	                            ),
	                            _react2.default.createElement('input', { type: 'email', placeholder: 'name@company.com', onChange: this.onChangeHandler.bind(this, 'email'), defaultValue: email, disabled: this.state.loading ? true : false, className: 'email-focus' }),
	                            checkFormat || this.state.email === '' ? '' : _react2.default.createElement(
	                                'span',
	                                { className: 'text-danger' },
	                                'email format is not correct'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'inputs' },
	                            _react2.default.createElement(
	                                'label',
	                                null,
	                                'Phone No'
	                            ),
	                            _react2.default.createElement('input', { type: 'number', placeholder: '+91 9988 766 554', onChange: this.onChangeHandler.bind(this, 'mobile'), defaultValue: mobile, disabled: this.state.loading ? true : false })
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'inputs' },
	                            _react2.default.createElement(
	                                'label',
	                                null,
	                                'What would you like to discuss?'
	                            ),
	                            _react2.default.createElement('textarea', { rows: '5', placeholder: 'Share a few details of the solution you are looking to find or wait! Let us get on a call & we will figure it out, for you.', defaultValue: description, onChange: this.onChangeHandler.bind(this, 'description'), disabled: this.state.loading ? true : false })
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'footer' },
	                        _react2.default.createElement(
	                            'button',
	                            { className: this.submitValidate() ? 'submit bt-blue' : 'submit bt-blue disable', id: this.state.loading ? 'bt-loading' : '', onClick: this.onSubmit.bind(this) },
	                            'Submit'
	                        )
	                    )
	                )
	            ),
	            _react2.default.createElement(
	                _ActiveWrapper2.default,
	                { active: this.state.sent },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'form-inputs-container' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'info-details' },
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'head' },
	                            'We have received your Support request'
	                        ),
	                        _react2.default.createElement(
	                            'p',
	                            null,
	                            'Our team will get back to you soon.'
	                        )
	                    )
	                )
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'form-inputs-container' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'info-details' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'head' },
	                        'Trusted by the world\u2019s best'
	                    )
	                )
	            ),
	            _react2.default.createElement(_CompanyLogos2.default, null)
	        );
	    };
	
	    return Sales;
	}(_react.Component);
	
	exports.default = Sales;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-customer-support-js-ff987db21ff88b921208.js